import { render } from "./OrganizationNew.vue?vue&type=template&id=d8be7ca6&ts=true"
import script from "./OrganizationNew.vue?vue&type=script&lang=ts"
export * from "./OrganizationNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__